import { parseDialogSchema } from '../parseDialogSchema';

/** @type {import('../parseDialogSchema').DialogSchemaInput} */
const raw = {
  id: 'club-event',
  titleAdd: 'Add Club Event',
  titleEdit: 'Edit Club Event',
  titleView: 'Event Details',
  fields: [
    {
      name: 'title',
      type: 'text',
      label: 'Event title',
      placeholder: 'Event title',
      required: true,
    },
    {
      type: 'row',
      columns: 2,
      fields: [
        { name: 'startsAt', type: 'datetime', label: 'Starts', required: true },
        { name: 'endsAt', type: 'datetime', label: 'Ends' },
      ],
    },
    { name: 'allDay', type: 'switch', label: 'All day' },
    { slot: 'recurrence' },
    {
      name: 'locationName',
      type: 'text',
      label: 'Location',
      placeholder: 'Location (optional)',
    },
    {
      name: 'description',
      type: 'textarea',
      label: 'Description',
      placeholder: 'Optional details',
      rows: 3,
    },
  ],
};

/** Parsed club event dialog schema (mirror clubEventForm.schema.yaml). */
export const clubEventFormSchema = parseDialogSchema(raw);
